"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinnerStatus = exports.spinnerAnimation = exports.spinner = exports.materialSpinner = void 0;
require("./styles.css");
var _tokens = require("@cbhq/cds-common/motion/tokens");
const spinner = {
  base: "cds-base-bbele0u"
};
exports.spinner = spinner;
const materialSpinner = {
  circle: "cds-circle-c1h5zt6h"
};
exports.materialSpinner = materialSpinner;
const spinnerAnimation = "cds-spinnerAnimation-s1vyox7j";
exports.spinnerAnimation = spinnerAnimation;
const spinnerStatus = "cds-spinnerStatus-s1sn1vmk";
exports.spinnerStatus = spinnerStatus;